export default "__VITE_ASSET__BbJ9MpPw__"